import { render, staticRenderFns } from "./PurchaseServiceNew2.vue?vue&type=template&id=0f683526"
import script from "./PurchaseServiceNew2.vue?vue&type=script&lang=js"
export * from "./PurchaseServiceNew2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports